
import { Outlet } from "react-router-dom";
import Footer from "../common/Footer";
import Header from "../common/Header";
const UserLayout = () => {
  return (
    <>
         <Header /> 
        <main>
          <Outlet />
        </main>
         <Footer /> 
  
    </>
  );
};

export default UserLayout;
